import { z } from "zod";

export const schema = z.object({
	id_conta_saidagrupo: z.number().int("Campo id_conta_saida_grupo é obrigatorio"),
	id_fornecedor: z.number().int("Campo Fornecedor é obrigatorio"),
	id_centrocusto: z.number().int("Campo Departamento de custo é obrigatorio"),
	id_conta_tipo: z.number().int("Campo Conta é obrigatorio"),
	id_funcionario: z.number().int("Campo Funcionário é obrigatorio"),
	descricao: z.string().nullable(),
	valor: z
		.union([z.string(), z.number()])
		.transform((value) => {
			// Se for string, converte para número
			if (typeof value === "string") {
				const parsedValue = parseFloat(value.replace(",", "."));
				return isNaN(parsedValue) ? 0 : parsedValue;
			}
			return value; // Já é número, mantém como está
		})
		.refine((value) => value > 0, {
			message: "Valor deve ser maior que 0",
		}),
	data: z.date({
		required_error: "Data de vencimento é obrigatória",
		invalid_type_error: "Data de vencimento inválida",
	}),

	ativo: z.boolean("Campo Ativo é obrigatorio"),
	obs: z.string().nullable(),
	parcelas: z.array(
		z.object({
			id: z.number(),
			id_conta_saida: z.number().int("Campo id é obrigatorio"),
			id_conta: z.number().int("Campo Conta é obrigatorio"),
			parcela: z.number().nullable(),
			parcela_total: z.number().nullable(),
			id_forma: z.number().int().min(1, "Forma de Pagamento é obrigatório"),
			valor: z.union([z.string(), z.number()]).transform((value) => {
				// Se for string, converte para número
				if (typeof value === "string") {
					const parsedValue = parseFloat(value.replace(",", "."));
					return isNaN(parsedValue) ? 0 : parsedValue;
				}
				return value; // Já é número, mantém como está
			}),
			data_vencimento: z.string().nonempty("A data é obrigatória"),
			ativo: z.boolean(),
		}),
	),
});

export const defaultValues = {
	id_conta_saidagrupo: 0,
	id_fornecedor: 1,
	id_centrocusto: 1,
	id_conta_tipo: 3,
	id_funcionario: 1,
	descricao: "",
	data: new Date(),
	ativo: true,
	valor: "",
	obs: "",
	parcelas: [
		{
			id: 0,
			id_conta_saida: 0,
			id_conta: 1,
			parcela: 1,
			id_conta_tipo: 3,
			parcela_total: 1,
			id_forma: 1,
			valor: "",
			data_vencimento: new Date().toISOString().split("T")[0],
			ativo: false,
		},
	],
};

// nome_fornecedor: "",
// id_conta: 1,
// id_forma: 1,

// forma: z.string().min(1, "Forma é obrigatorio"),
// forma: "DINHEIRO",
